<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/VentaPago`;

function authHeaders() {
  return {
    'Authorization': `Bearer ${utilsService.getToken()}`,
    'Content-Type': 'application/json',
  };
}

async function registrarPago(data) {
  const response = await axios.post(`${apiUrl}/registrar`, data, {
    headers: authHeaders(),
  });
  return response.data;
}

async function getPagosByVenta(idVenta) {
  const response = await axios.get(`${apiUrl}/obtener/${idVenta}`, {
    headers: authHeaders(),
  });
  return response.data;
}

async function editarPago(id, data) {
  const response = await axios.put(`${apiUrl}/actualizar/${id}`, data, {
    headers: authHeaders(),
  });
  return response.data;
}

export default {
  registrarPago,
  getPagosByVenta,
  editarPago,
};
</script>
